import { render } from "./ItMuseo.vue?vue&type=template&id=1164486d"
import script from "./ItMuseo.vue?vue&type=script&lang=js"
export * from "./ItMuseo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\marco\\Desktop\\archeo-guida-smart\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__